export default __webpack_public_path__ + "f06798680d61ef435d3affd29c42d63c.svg";